import { GlobalConfigType } from 'actions'
import cloneDeep from 'clone-deep'
import { InputType } from 'config'
import { defaultInputs as PartyInputs } from 'pages/Loan/Parties/Modal/config'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RenderInput } from 'utils/RenderInput'

import { ILinkToPartyValue } from '../../BorrowerPipelineConfiguration/types'

const defaultInputs = (): Record<string, InputType> => {
  const inputOptions: Record<string, string> = {}
  const partyInputs = PartyInputs()
  Object.keys(partyInputs).forEach((key) => {
    inputOptions[key] = partyInputs[key].title
  })

  return {
    isActive: {
      inputType: 'togglebutton',
      title: 'Link to Party',
      value: false,
      required: true,
      span: 2,
      visible: true,
    },
    type: {
      inputType: 'select',
      title: 'Type',
      options: [],
      hasDefaultOption: true,
      required: true,
      sort: true,
    },
    input: {
      inputType: 'select',
      title: 'Input',
      options: inputOptions,
      hasDefaultOption: true,
      required: true,
    },
  }
}

export const LinkToParty = ({ value, onChange: _onChange }: { value?: ILinkToPartyValue; onChange: Function }) => {
  const [inputs, setInputs] = useState(defaultInputs())

  const partyOptions = useSelector((state: any) => state.globalConfigReducer[GlobalConfigType.PARTIES])

  useEffect(() => {
    initPartyTypes()
  }, [partyOptions])

  const initPartyTypes = () => {
    const { isActive = false } = value || {}
    const newInputs = cloneDeep(inputs)
    newInputs.type.visible = isActive
    newInputs.input.visible = isActive
    value &&
      Object.keys(value).forEach((key) => {
        newInputs[key].value = (value as any)[key]
      })
    ;(newInputs.type as any).options = partyOptions
    setInputs(newInputs)
  }

  const onChange = (key: string, value: any) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    if (key == 'isActive') {
      newInputs.type.visible = value
      newInputs.input.visible = value
    }
    setInputs(newInputs)

    const data: Record<string, any> = {}
    Object.keys(newInputs).forEach((key) => {
      data[key] = newInputs[key].value
    })
    _onChange(data)
  }

  return (
    <div>
      <div className="grid md:grid-cols-2 gap-4">
        {Object.keys(inputs).map((key) => {
          const input = inputs[key]
          if (!input.visible) return null
          return (
            <div className={`col-span-${input.span || 1}`}>
              <RenderInput Key={key} input={input} onChange={onChange} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
